// extracted by css-extract-rspack-plugin
export default {"paymentRequestScreenContainer":"paymentRequestScreenContainer-IWY1UY"};